import { useFormDispatch, useFormSelector } from '../../contexts';
import { verifyRecaptcha } from '../../recaptcha/verify-recaptcha';

export function useHandleFieldsErrors() {
  const { fieldsError } = useFormSelector();
  const dispatch = useFormDispatch();

  return async (recaptcha: boolean) => {
    if (Object.values(fieldsError).filter(Boolean).length > 0) {
      dispatch({
        type: 'setError',
        fieldsError: { invalid: true },
        status: 'invalid'
      });

      return 'invalid';
    }

    const isRecaptchaVerified = await verifyRecaptcha(recaptcha);

    if (!isRecaptchaVerified) {
      dispatch({
        type: 'setStatus',
        status: 'failed'
      });

      return 'failed';
    }

    return undefined;
  };
}
